import { render, staticRenderFns } from "./GraficosApi.vue?vue&type=template&id=5ef16e70&"
import script from "./GraficosApi.vue?vue&type=script&lang=js&"
export * from "./GraficosApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports